import React, { useState, useEffect } from 'react';
import { supabase, isSupabaseConfigured } from '../../lib/supabase';

const DashboardStats: React.FC = () => {
  const [stats, setStats] = useState({
    patients: 0,
    pendingSamples: 0,
    validatedSamples: 0
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchStats = async () => {
      if (!isSupabaseConfigured()) {
        // Mock data
        setStats({ patients: 1240, pendingSamples: 45, validatedSamples: 328 });
        setLoading(false);
        return;
      }

      try {
        // Patients count
        const { count: patientCount } = await supabase
          .from('patients')
          .select('*', { count: 'exact', head: true });

        // Pending samples (received)
        const { count: pendingCount } = await supabase
          .from('samples')
          .select('*', { count: 'exact', head: true })
          .eq('status', 'received');

        // Validated samples
        const { count: validatedCount } = await supabase
          .from('samples')
          .select('*', { count: 'exact', head: true })
          .eq('status', 'validated');

        setStats({
          patients: patientCount || 0,
          pendingSamples: pendingCount || 0,
          validatedSamples: validatedCount || 0
        });
      } catch (e) {
        console.error("Error fetching stats", e);
      } finally {
        setLoading(false);
      }
    };

    fetchStats();
  }, []);

  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
      <div className="bg-white p-6 rounded-xl shadow-sm border border-slate-200">
        <h3 className="text-slate-500 text-sm font-medium">Patients Enregistrés</h3>
        <p className="text-3xl font-bold text-slate-800 mt-2">
          {loading ? '...' : stats.patients}
        </p>
        <div className="mt-2 text-xs text-emerald-600 font-medium">Base active</div>
      </div>
      <div className="bg-white p-6 rounded-xl shadow-sm border border-slate-200">
        <h3 className="text-slate-500 text-sm font-medium">Prélèvements en attente</h3>
        <p className="text-3xl font-bold text-slate-800 mt-2">
          {loading ? '...' : stats.pendingSamples}
        </p>
        <div className="mt-2 text-xs text-orange-600 font-medium">Nécessite action</div>
      </div>
      <div className="bg-white p-6 rounded-xl shadow-sm border border-slate-200">
        <h3 className="text-slate-500 text-sm font-medium">Analyses Validées</h3>
        <p className="text-3xl font-bold text-slate-800 mt-2">
          {loading ? '...' : stats.validatedSamples}
        </p>
        <div className="mt-2 text-xs text-indigo-600 font-medium">Total réalisé</div>
      </div>
    </div>
  );
};

export default DashboardStats;
